import { useNavigate } from "react-router-dom";
import img from '../assets/pageNotFound.png';

const Notfound = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen text-gray-800 px-4">
            <div className="notfoundpage flex flex-col items-center mb-6">
                <div className="text-2xl md:text-3xl text-center mb-4">Page Not Found</div>
                <img className="h-72 md:h-96" src={img} alt="Page Not Found" />
            </div>
            <button 
                onClick={handleGoHome}
                className="p-3 bg-gray-200 text-xl rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
                Go Home
            </button>
        </div>
    );
}

export default Notfound;
